import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type QueryContextProps = {
  children: React.ReactElement;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const QueryProvider: React.FC<QueryContextProps> = (props) => {
  const { children } = props;
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default QueryProvider;
